import React from "react";

// External
import { graphql } from "gatsby";

// Sections
import Layout from "../components/layout";
import HeroSection from "../containers/hero-section";
import UnlockingSuccessSection from "../containers/unlocking-success-section";
import Seo from "../components/SEO";
import ProjectsSection from "../containers/projects-section";
import BlogSection from "../containers/blog-section";
import ReviewsSection from "../containers/reviews-section";
import WhatWeProvideSection from "../containers/what-we-provide-section";
import TechnologySection from "../containers/technology-section";
import ClearPictureSection from "../containers/clear-picture-section";
import FaqSection from "../containers/faq-section";
import ContactMeSection from "../containers/contact-me-section";

// Query for fetching maximum 4 blog posts in a sorted manner
export const pageQuery = graphql`
  query FETCH_BLOG_POSTS {
    allMdx(
      sort: { fields: frontmatter___date, order: DESC }
      limit: 4
      filter: { frontmatter: { published: { eq: true } } }
    ) {
      nodes {
        id
        frontmatter {
          slug
          title
          description
          series
          cover_src
          date(formatString: "Do MMM, YYYY")
          read_time
        }
      }
      totalCount
    }
  }
`;

const IndexPage = ({
  data: {
    allMdx: { nodes: blogPosts },
  },
}) => {
  return (
    <Layout>
      <Seo />
      <HeroSection />
      <UnlockingSuccessSection />
      <ProjectsSection />
      <WhatWeProvideSection />
      <TechnologySection />
      <ReviewsSection />
      <BlogSection blogPosts={blogPosts} preview />
      <ClearPictureSection />
      <FaqSection />
      <ContactMeSection />
    </Layout>
  );
};

export default IndexPage;
